import Controller from './dwstroy.group_tours_iran/controller';

(function (window){
    'use strict';

    if (window.JCDwsGroupToursIran)
        return;

    Controller();

})(window);